"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Dtfprinting() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  return <section data-section-id="2272" id="premium-dtf-transfer-solutions" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 z-30 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")"
    }} aria-hidden="true" />

      {}
      <div ref={imgRef} className={`absolute inset-y-0 right-0 z-10 w-full md:w-[65%] lg:w-[60%] transition-all duration-[1400ms] ease-out ${imgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="relative h-full w-full">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1720440/img/dtf_printing_texture.png" alt="High-quality DTF film print texture on fabric" className="h-full w-full object-cover object-center opacity-60 md:opacity-100" loading="lazy" decoding="async" src="https://evolving-grouper.10web.cloud/wp-content/uploads/2026/06/hq720.jpg" />
          {}
          <div className="absolute inset-0 bg-gradient-to-r from-background via-background/70 to-transparent md:via-background/40" />
          <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-background/40" />
        </div>
      </div>

      {}
      <div className="absolute top-0 right-4 md:right-6 z-20 hidden sm:flex h-full items-start pt-24 lg:pt-32">
        <div className="overflow-hidden h-[60vh]" style={{
        writingMode: "vertical-rl"
      }}>
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-foreground/40 whitespace-nowrap" style={{
          animation: "valveMarquee 18s linear infinite"
        }}>
            CMYK+W — 1440 DPI — DURABLE WASH — FAST DRY — CMYK+W — 1440 DPI — DURABLE WASH — FAST DRY —
          </div>
        </div>
        <style>{`
          @keyframes valveMarquee {
            0% { transform: translateY(-50%); }
            100% { transform: translateY(0%); }
          }
        `}</style>
      </div>

      {}
      <div className="relative z-20 mx-auto flex min-h-screen max-w-[1600px] flex-col justify-end px-5 sm:px-8 lg:px-12 pt-28 pb-20 md:pb-28">
        {}
        <div ref={eyebrowRef} className={`mb-10 md:mb-16 flex items-center gap-4 transition-all duration-700 ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.25em]" style={{
          color: "var(--primary)"
        }}><span className="text-primary !text-lg"><span className="!text-base"><span className="!text-4xl">GREAT STATE DTF</span></span></span></span>
          <span className="h-px flex-1 max-w-[120px] sm:max-w-[180px]" style={{
          backgroundColor: "var(--primary)"
        }} />
        </div>

        {}
        <div ref={headlineRef} className={`transition-all duration-1000 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-default font-black uppercase leading-[0.85] text-foreground" style={{
          fontSize: "clamp(4rem, 14vw, 11rem)",
          letterSpacing: "-0.04em"
        }}>
            <span className="block text-primary">fast</span>
            <span className="block !text-[rgba(0,0,0,0.88)] !bg-transparent !font-sans" style={{
            color: "transparent",
            WebkitTextStroke: "1.5px hsl(220 10% 45%)"
          }}><span className="!text-[rgba(0,0,0,0.88)]" data-ast-id="f:/src/pages/Home/sections/Dtfprinting.tsx|sig:9x5rxb" data-ast-start="4486" data-ast-end="4541"></span></span>
            <span className="block !bg-[rgba(0,33,165,0)] text-primary">QUALITY</span><span className="block !bg-[rgba(0,33,165,0)] text-primary">TRANSFERS</span>
          </h1>
        </div>

        {}
        <div ref={subRef} className={`mt-8 md:mt-12 max-w-[50ch] transition-all duration-700 delay-100 ${subVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="font-default text-lg sm:text-xl text-foreground leading-relaxed">
            Transform your digital designs into high-quality, durable apparel prints. Precision heat-press technology for vibrant, long-lasting results.
          </p>
        </div>

        {}
        <div ref={ctaRef} className={`mt-10 md:mt-12 flex flex-col sm:flex-row gap-4 sm:gap-5 transition-all duration-700 delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Link to="#">
            <Button size="lg" className="h-14 px-8 font-default font-bold uppercase tracking-wider text-sm bg-primary text-primary-foreground hover:bg-primary/90 shadow-2xl">
              START YOUR RUN
              <ArrowRight className="ml-1 h-4 w-4" />
            </Button>
          </Link>

          <Link to="#">
            <Button size="lg" variant="outline" className="h-14 px-8 font-default font-bold uppercase tracking-wider text-sm bg-transparent border border-foreground/40 text-foreground hover:bg-foreground hover:text-background">
              OUR TECHNOLOGY
            </Button>
          </Link>
        </div>

        {}
        <div className="mt-16 md:mt-20 flex items-end justify-between gap-6">
          {}
          <div className="flex flex-col items-center gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.4em] text-foreground/60" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              SCROLL
            </span>
            <span className="block w-px h-16 md:h-20" style={{
            background: "linear-gradient(to bottom, var(--primary), transparent)",
            animation: "valveScrollPulse 2.4s ease-in-out infinite"
          }} />
            <style>{`
              @keyframes valveScrollPulse {
                0%, 100% { opacity: 0.3; transform: scaleY(0.7); transform-origin: top; }
                50% { opacity: 1; transform: scaleY(1); transform-origin: top; }
              }
            `}</style>
          </div>

          {}
          <div className="hidden md:flex flex-col items-end gap-1 font-mono text-[11px] uppercase tracking-[0.15em] text-foreground/70">
            <div className="flex items-center gap-3">
              <span className="inline-block h-1.5 w-1.5" style={{
              backgroundColor: "var(--primary)"
            }} />
              <span>VIBRANT COLOR</span>
            </div>
            <div>FAST TURNAROUND</div>
            <div style={{
            color: "var(--primary)"
          }}>ECO-CONSCIOUS</div>
          </div>
        </div>
      </div>
    </section>;
}